import axios from 'axios';
import { FiltrosReporte, ReporteConsolidado } from '../types/consolidatedReport.types';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5001';

class ConsolidatedReportService {
  /**
   * Genera un reporte consolidado basado en los filtros proporcionados
   */
  async generateReport(filters: FiltrosReporte): Promise<ReporteConsolidado> {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${API_URL}/api/consolidated-reports/generate`,
        filters,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      return response.data.data;
    } catch (error: any) {
      console.error('Error al generar reporte consolidado:', error);
      throw error.response?.data || { error: 'Error al generar el reporte' };
    }
  }

  /**
   * Descarga el PDF del reporte consolidado
   */
  async downloadPDF(filters: FiltrosReporte): Promise<void> {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${API_URL}/api/consolidated-reports/pdf`,
        filters,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          responseType: 'blob'
        }
      );

      // Crear un enlace temporal para descargar el archivo
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      
      // Generar nombre del archivo
      const fecha = new Date().toISOString().split('T')[0];
      link.setAttribute('download', `reporte-consolidado-${fecha}.pdf`);
      
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error: any) {
      console.error('Error al descargar PDF:', error);
      throw error.response?.data || { error: 'Error al descargar el PDF' };
    }
  }

  /**
   * Descarga el Excel detallado del reporte consolidado (pregunta por pregunta)
   */
  async downloadExcel(filters: FiltrosReporte): Promise<void> {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${API_URL}/api/consolidated-reports/excel`,
        filters,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          responseType: 'blob'
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const fecha = new Date().toISOString().split('T')[0];
      link.setAttribute('download', `reporte-consolidado-${fecha}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error: any) {
      console.error('Error al descargar Excel:', error);
      throw error.response?.data || { error: 'Error al descargar el Excel' };
    }
  }
}

export default new ConsolidatedReportService();
